<div role="row" class="visually-hidden">
  <div role="columnheader">{{ dsoType + '.edit.metadata.headers.value' | translate }}</div>
  <div role="columnheader">{{ dsoType + '.edit.metadata.headers.language' | translate }}</div>
  <div role="columnheader">{{ dsoType + '.edit.metadata.headers.edit' | translate }}</div>
</div>
